
import { PageHeader } from '../PageHeader/PageHeader'
import skill from './Skills.module.css'

const skills = [
    {
        image : 'https://img.icons8.com/color/144/000000/html-5--v1.png',
        title : 'HTML'
    },
    {
        image : 'https://img.icons8.com/color/144/000000/css3.png',
        title : 'CSS'
    },
    {
        image : "https://img.icons8.com/color/144/000000/javascript--v1.png",
        title : 'JavaScript'
    },
    {
        image : 'https://cdn.auth0.com/blog/react-js/react.png',
        title : 'React'
    },
    {
        image : 'https://raw.githubusercontent.com/reactjs/redux/master/logo/logo.png',
        title : 'Redux'
    },
    {
        image : 'https://pluspng.com/img-png/nodejs-logo-png-create-a-model-to-persist-data-in-a-node-js-loopback-api-from-beeman-nl-on-eggheadio-1200.png',
        title : 'Node Js'
    },
    {
        image : 'https://png2.cleanpng.com/sh/46111f8258e7469d4d7f83eda8c1191f/L0KzQYm3VsA1N5DnjpH0aYP2gLBuTgdmal5pfehubHBzfbb1lL1mgKF3feV8LXr2PbvolvF0a6NuiOY2c3BphMjokvUubqNmRdh7YX3oPcj2kvsuPZM2TaMAM3S1RLW6hsYvQWI4S6M8M0C0RYOBUcA5O2UASac5OT7zfri=/kisspng-web-development-express-js-javascript-software-fra-frame-work-5b15153d24d3f6.9133133015281083491509.png',
        title : 'Express Js'
    },
    {
        image : "https://img.icons8.com/color/144/000000/mongodb.png",
        title : 'MongoDB'
    },
    {
        image : "https://img.icons8.com/color/48/000000/material-ui.png",
        title : 'Material UI'
    },
    {
        image : "https://img.icons8.com/color/48/000000/npm.png",
        title : 'NPM'
    },
    {
        // image : "https://img.icons8.com/ios-filled/100/000000/git.png",
        image : "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
        title : 'Git'
    }
]

const Skills = () => {
    return (
        <div className={skill.skills} id="skills">
            <PageHeader title={'Skills'} /> 
            <div className={skill.skillCont}>
            {
                
                skills.map(({image, title}) => {
                    return (
                        <>
                        <div className={skill.skillName}>
                            <img  src={image} alt={title} />
                            <span >{title}</span>
                        </div>
                        </>
                    )
                })
            }
            </div>
        </div>
    )
} 

export {Skills}
